"use client";

import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const faqs = [{
  question: "How do I select the right study destination?",
  answer: "Our expert advisors provide personalized assessments based on your academic background, career aspirations, and financial preferences to help you select the ideal university in the UK, USA, or Canada."
}, {
  question: "What is Briviox's visa success rate?",
  answer: "We maintain an industry-leading visa success rate. Our dedicated admissions team provides comprehensive guidance on documentation, financial proofing, and interview preparation to ensure a frictionless process."
}, {
  question: "Are there scholarships available for international students?",
  answer: "Yes, many of our partner institutions offer merit-based and need-based scholarships. We proactively identify and assist you in applying for all eligible financial aid opportunities to make your global education more accessible."
}, {
  question: "When should I begin the application process?",
  answer: "Ideally, you should start 8–12 months before your intended intake. This timeline allows ample time for university applications, English proficiency testing, and the detailed student visa application process."
}, {
  question: "Is the initial consultation truly free?",
  answer: "Absolutely. Your first consultation with Briviox is completely free of charge. We believe in providing transparent, authoritative guidance from the very first meeting to help you map your future with confidence."
}];
export default function CollaborationFaqs() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="23365" id="common-inquiries" className="bg-background text-foreground py-24 px-6 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full max-w-7xl pointer-events-none opacity-30">
        <div className="absolute top-[10%] left-[20%] w-96 h-96 bg-primary/5 rounded-full blur-[100px]" />
        <div className="absolute bottom-[10%] right-[20%] w-64 h-64 bg-secondary/10 rounded-full blur-[80px]" />
      </div>

      <div ref={ref} className={`max-w-[800px] mx-auto relative z-10 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-default font-bold mb-6 tracking-tight text-primary">
            Common Inquiries
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto font-default">
            Answers to common questions about our institutional process, university timelines, and scholarship support.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full space-y-2">
          {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-b border-border/60 data-[state=open]:bg-muted/40 data-[state=open]:border-transparent transition-all duration-300 rounded-lg px-2">
              <AccordionTrigger className="text-lg md:text-xl font-default font-semibold py-6 px-4 hover:no-underline hover:text-secondary transition-colors text-left text-primary">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground text-base font-default leading-relaxed px-4 pb-6">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>

        <div className="mt-16 text-center">
          <p className="text-muted-foreground mb-6 font-default">
            Still have questions? Our academic advisors are here to help.
          </p>
          <Button asChild size="lg" className="rounded-lg px-8 bg-gradient-to-r from-primary to-secondary hover:opacity-90 transition-opacity font-default">
            <Link to="#">
              Schedule Free Consultation
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}